import experimentationConfig from 'etc/experimentationConfig.json';

// "In summary, we recommend looking for the string 'Mobi' anywhere in the User Agent to detect a mobile device."
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
// In short: userAgent detection is a horrible praxis, but we've settled for a basic one here, that simply involves most mobiles.
// Tests should not depend entirely on this kind of filtering, since our site is responsive.
const isMobile = userAgent => /Mobi/i.test(userAgent);

export const isExperimentValid = (experiment, market) => {
  const customConfig = experimentationConfig[experiment];

  // No custom config - this experiment runs everywhere
  if (!customConfig) {
    return true;
  }

  // Market restrictions
  if (market && customConfig.markets && !customConfig.markets.includes(market)) {
    return false;
  }

  // "Only mobile" restriction
  if (customConfig.mobileOnly && !isMobile(navigator && navigator.userAgent)) {
    return false;
  }

  return true;
};
